export default "__VITE_ASSET__BTYD_oRb__"